import * as React from 'react'

const ReferralContext = React.createContext({
  referralId: ''
})

export default ReferralContext
